import { CommitmentCodeEnum } from './commitments.ts';

export enum GiftFundCodesEnum {
  Birthday = CommitmentCodeEnum.BirthdayGift,
  Center = CommitmentCodeEnum.CenterGift,
  Child = CommitmentCodeEnum.ChildGift,
  Family = CommitmentCodeEnum.FamilyGift,
  Final = CommitmentCodeEnum.FinalGift,
}

export enum GiftLimitReason {
  AlreadyGivenBirthday = 'BG-Gift-Already-Given',
  AlreadyGivenChild = 'GG-Gift-Already-Given',
  AlreadyGivenMaxTimesChild = 'GG-Gift-Already-Given-Max-Times',
  AlreadyGivenGraduation = 'GDG-Gift-Already-Given',
  AlreadyGivenFinal = 'FLG-Gift-Already-Given',
  AlreadyGivenMaxAmountCenter = 'PG-Max-Amount-Already-Given',
  AlreadyGivenMaxAmountFamily = 'FG-Max-Amount-Already-Given',
  IneligibleBeneficiaryExited = 'Beneficiary-Exited',
  IneligiblePlannedExit = 'Beneficiary-PlannedExit',
}
